import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Stacked from '../../shared/Stacked/stacked.vue';
import EpicBody from '../EpicBody/epic.body.vue';
import EpicFeatureCard from '../EpicFeatureCard/epic.feature.card.vue';

@Component({
    components: {
        Stacked,
        EpicBody,
        EpicFeatureCard
    }
})
export default class EpicFeatures extends Vue {
    public title: string = 'EpicFeatures';

    public features: any = [
        {
            icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-features/research.svg',
            title: 'Research suburbs',
            content: 'Big-Data provides multiple information from your living environment.',
            slogan: 'research now',
            link: '/research-suburb',
        },
        {
            icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-features/brokerage.svg',
            title: 'We do home loans',
            content: 'Easy to share and edit E-Business Card with your clients by just one touch !',
            slogan: 'Learn More',
            link: '/home-loan',
        },
        {
            icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-features/smartphone.svg',
            title: 'Flat Processing System',
            content: 'See your transaction process clearly and organize easily ever !',
            slogan: 'Explore options',
            link: '/download-app',
        }
    ];

    @Prop({ default: undefined })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
}
